import React, { useState } from 'react';
import './DashboardTable.scss';  // Assuming you have CSS for styling
import PlusIcon from './../../../../Assets/icons/plus-circle.svg'
import MinusIcon from './../../../../Assets/icons/Minus-circle.svg'
const ExpandableTable = ({ productData }) => {
  const [activeKey, setActiveKey] = useState(null);

  const toggleAccordion = (index) => {
    setActiveKey(activeKey === index ? null : index);
  };

  return (
    <div className="expandable-table">
      {/* Header */}
      <div className="table-header">
        <div className="header-item">Vendor</div>
        <div className="header-item">Product</div>
        <div className="header-item">Make</div>
        <div className="header-item">Model</div>
        <div className="header-item">Variant</div>
        
        <div className="header-item"></div>
       
      </div>

      {/* Rows */}
      {productData.map((product, index) => (
        <div key={index} className={`table-row ${activeKey === index ? 'expanded-row' : ''}`}>
          {/* Row Summary */}
          <div className="row-content" onClick={() => toggleAccordion(index)}>
            <div className="row-item">{product.companyname}</div>
            <div className="row-item">{product.product}</div>
            <div className="row-item">{product.make_name}</div>
            <div className="row-item">{product.model_name}</div>
            <div className="row-item">{product.variant_name}</div>
          
            <div className="row-item"> <button
              className="expand-button"
              onClick={() => toggleAccordion(index)}
              aria-expanded={activeKey === index}
            >
              {activeKey === index ?  <img src={MinusIcon}></img>: <img src={PlusIcon}></img>}
            </button></div>
            {/* <button
              className="expand-button"
              onClick={() => toggleAccordion(index)}
              aria-expanded={activeKey === index}
            >
              {activeKey === index ? 'Collapse' : 'Expand'}
            </button> */}
          </div>

          {/* Expanded Content */}
          {activeKey === index && (
            <div className="accordion-content-logistics">
              {/* Nested Table for Additional Product Details */}
              <div className="nested-table">
                <div className="nested-header">
                  <div className="header-item" >Location</div>
                  <div className="header-item">Branch</div>
                  <div className="header-item">Purchase Qty</div>
                  <div className="header-item">Good Qty</div>
                  <div className="header-item">Sold Qty</div>
                  <div className="header-item">Price (per qty)</div>
                </div>
                {product.details.map((detail, detailIndex) => (
                  <div key={detailIndex} className="nested-row">
                    <div className="row-item">{detail.location}</div>
                    <div className="row-item">{detail.showroom}</div>
                    <div className="row-item">{detail.accepted_qty}</div>
                    <div className="row-item">{detail.good_qty - detail.sold_qty}</div>
                    <div className="row-item">{detail.sold_qty}</div>
                    <div className="row-item">{detail.purchase_price}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ExpandableTable;
